export const master_top_container_Style = {
  masterTextSx: {
    color: 'text.primary',
    fontSize: '16px',
    fontWeight: 'medium',
  },
  masterBadgeTextSx: {
    color: 'text.primary',
    fontSize: '16px',
    fontWeight: 'medium',
  },
  BadgeSx: {
    display: 'flex',
    width: '23px',
    height: '23px',
    fontSize: '14px',
    fontWeight: 'medium',
    borderRadius: '100%',
    backgroundColor: '#0F0B11',
    color: '#fff',
    ml: 0.4,
    p: 0.3,
    justifyContent: 'center',
    alignItems: 'center',
  },
  uploadButtonSx: {
    display: 'flex',
    width: 128,
    height: 40,
    color: 'primary.main',
    border: '2px solid ',
    boderColor: 'primary.main',
    borderRadius: '4px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#e0e0e0',
    },
  },
  unSelectAvailabilityButtonSx: {
    fontSize: '14px',
    fontWeight: 'medium',
    color: 'primaryTints.A100',
  },
  buttonSx: {
    color: 'primary.main',
    border: '2px solid',
    fontSize: '14px',
    fontWeight: 'medium',
    borderColor: 'primary.main',
    height: '40px',
    width: '128px',
    borderRadius: '8px',
    textTransform: 'capitalize',
  },
  addMasterSx: {
    textTransform: 'capitalize',
    height: '40px',
    width: 'max-content',
    borderRadius: '8px',
    whiteSpace: 'nowrap',
  },
  searchFieldSx: {
    width: '360px',
    borderRadius: '8px',
    '& .MuiOutlinedInput-notchedOutline': {
      px: 2,
      height: '44px',
      border: 'none',
    },

    '&.MuiFormControl-root': {
      backgroundColor: '#fff',
      pb: '4px',
    },
    ' & .MuiOutlinedInput-input': {
      color: 'text.primary',
      backgroundColor: '#fff',

      pt: 0.5,
    },
    '& .MuiOutlinedInput-root': {
      px: 0,
      pt: 0.7,
      backgroundColor: 'tranparent',
      color: '#025140',
      '& fieldset': {
        borderRadius: '8px',
        border: '1.5px solid',
        borderColor: '#C5C5C5',
      },
      '&:hover fieldset': {
        borderColor: 'border.hover',
      },
      '&.Mui-focused fieldset': {
        borderColor: 'border.focus',
      },
    },
  },
};

// '&.MuiFormControl-root': {
//       backgroundColor: 'transparent',
//     },
//     '& .MuiOutlinedInput-root': {
//       px: 0,
//       pt: 0.7,
//       backgroundColor: 'common.white',
//       borderRadius: '8px',
//       color: 'grey',
//       '& fieldset': {
//         borderRadius: '8px',
//         border: '1.5px solid',
//         borderColor: 'border.main',
//       },
//       '&:hover fieldset': {
//         border: '1.5px solid',
//         borderColor: 'border.hover',
//       },
//       '&.Mui-focused fieldset': {
//         border: '1.5px solid',
//         borderColor: 'border.focus',
//       },
//     },
//     '& .MuiOutlinedInput-input': {
//       padding: '0px 4px 5px 10px',
//       fontSize: '14px',
//     },
//     width: '100%',
//     '& .MuiOutlinedInput-notchedOutline': {
//       border: 'none',
//     },
